module.exports = __webpack_public_path__ + "img/239-1fa8ee.png";